<form [formGroup]="formGroup" [id]="'phoneform-'+key" class="phoneform" data-form="phone-form">
  <ngx-intl-tel-input [cssClass]="'custom'" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
    [preferredCountries]="preferredCountries" [searchCountryFlag]="true" [selectedCountryISO]="countryISO"
    [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [separateDialCode]="true"
    [phoneValidation]="true" [maxLength]="15" name="phone" (countryChange)="countryChange($event)"
    formControlName="phone"></ngx-intl-tel-input>
</form>